import { AllFlagsScreen } from './AllFlagsScreen';
import { useUserData } from './UserDataContext';
import { toast } from 'sonner';

interface AllFlagsScreenWrapperProps {
  onBack: () => void;
}

export function AllFlagsScreenWrapper({ onBack }: AllFlagsScreenWrapperProps) {
  const { userProfile, updateProfile } = useUserData();

  const handleSave = (selection: { name: string; code: string; flag: string; type: 'country' | 'region' }) => {
    // 🏳️ ORIGIN FLAG RULE: Always set the selected flag as the origin flag.
    // There are no exceptions — this is the user's heritage flag, not their residence.
    updateProfile({
      country: selection.name,       // Origin country name
      countryFlag: selection.flag,   // Origin flag code
    });

    toast.success(`${selection.name} set as your origin flag!`);
    
    // 📢 Dispatch event for EditProfileScreen or others to sync local state
    window.dispatchEvent(new CustomEvent('flagSelected', { 
      detail: { name: selection.name, code: selection.flag } 
    }));

    onBack();
  };

  return (
    <AllFlagsScreen
      currentCountry={userProfile.country}
      onBack={onBack}
      onSave={handleSave}
    />
  );
}
